import { FinanceSettingsLayout } from "./Components/FinanceSettingsLayout";
import { useMediaQuery } from "usehooks-ts";
import PayoutTable from "./Components/PayoutTable";
import { PayoutCardList } from "./Components/PayoutCardList";
import { Navigate, useSearchParams } from "react-router";
import * as ROUTES from "../../../constants/routes";
import { usePayoutFromInvoiceId } from "../../../hooks/api/v2/payout/usePayoutFromInvoiceId";
import { SpinnerLegacy } from "../../../components";

export const FinanceSettingsPayout = () => {
  const [searchParams] = useSearchParams();
  const isDesktop = useMediaQuery("(min-width: 1200px)");

  const invoiceId = Number(searchParams.get("invoiceId"));
  const payout = usePayoutFromInvoiceId(isNaN(invoiceId) ? -1 : invoiceId);

  const { data, isLoading, isError } = payout;

  if (isLoading) {
    return <SpinnerLegacy />;
  }

  if (isError || !data || !data.Invoices || data.Invoices.length === 0) {
    return <Navigate to={ROUTES.BUSINESS_FINANCE_CREDIT} />;
  }

  return (
    <FinanceSettingsLayout>
      {isDesktop ? (
        <PayoutTable payout={data} setActive={() => {}} />
      ) : (
        <PayoutCardList payout={data} setActive={() => {}} />
      )}
    </FinanceSettingsLayout>
  );
};
